import type { UserConfig } from "vite-plus";

export const lintPreset = (): UserConfig["lint"] => {
  return {
    ignorePatterns: ["__snapshots__/**/*", "dist/**/*", "coverage/**/*"],
    options: {
      typeAware: true,
      typeCheck: true,
    },
  };
};
